import { Select } from "../Select/Select";
import CheckboxesWidget from "./CheckboxesWidget";

const CustomSelect = (props: any) => {
  if (props.schema?.uiWidget === "checkboxes") {
    return <CheckboxesWidget {...props} />;
  }

  return (
    <Select
      id={props.id}
      onChange={props.onChange}
      options={props.options.enumOptions}
      isDisabled={props.disabled}
      value={props.value}
      onBlur={props.onBlur}
      schema={props.registry.rootSchema}
    />
  );
};

export default CustomSelect;
